import PropTypes from "prop-types";

const FormSuccessMessage = ({
  title,
  message,
  icon = "fas fa-check-circle",
}) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center p-5" style={{ maxWidth: "600px" }}>
        <div
          className="card shadow-lg border-0"
          style={{ borderRadius: "20px" }}
        >
          <div className="card-body p-5">
            {/* Success Icon */}
            <div className="mb-4">
              <div
                className="mx-auto d-flex align-items-center justify-content-center"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #28a745, #20c997)",
                  boxShadow: "0 10px 30px rgba(40, 167, 69, 0.4)",
                }}
              >
                <i
                  className={`${icon} text-white`}
                  style={{ fontSize: "2.5rem" }}
                ></i>
              </div>
            </div>

            {/* Title */}
            <h2 className="mb-4 fw-bold" style={{ color: "#2c3e50" }}>
              {title}
            </h2>

            {/* Message */}
            <p
              className="text-muted mb-4"
              style={{ fontSize: "1.1rem", lineHeight: "1.7" }}
            >
              {message}
            </p>

            {/* Decorative Line */}
            <div
              className="mx-auto mb-4"
              style={{
                width: "80px",
                height: "4px",
                background: "linear-gradient(90deg, #28a745, #20c997)",
                borderRadius: "2px",
              }}
            ></div>

            {/* Success Animation */}
            <div className="mt-4">
              <div className="d-flex justify-content-center align-items-center">
                <div
                  className="me-3"
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    background: "#28a745",
                    animation: "pulse 2s infinite ease-in-out",
                  }}
                ></div>
                <small className="text-success fw-semibold">
                  Successfully Processed
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FormSuccessMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default FormSuccessMessage;
